module.exports = __webpack_public_path__ + "img/newyear2024-qrcode.5a36c494.png";